import React from "react";
import Home from "./screens/Home";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <Home></Home>
    </div>
  );
}

export default App;
